import { render, staticRenderFns } from "./PazienteAnagraficaLeonida.vue?vue&type=template&id=34c58b77"
import script from "./PazienteAnagraficaLeonida.vue?vue&type=script&lang=js"
export * from "./PazienteAnagraficaLeonida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports